<template>
    <div v-if="event_value" @mouseover="showIcons = true && current_user_id" @mouseleave="showIcons = always_visible" @click="showIcons = true && current_user_id">

        <span v-if="current_user_label && current_user_label.new_value" class="text-primary">{{ current_user_label.new_value }}* </span>

        <span v-if="value" :class="{ 'text-strike': correct === false }">{{ value }}</span>

        <!-- <span v-if="event_value.value && event_value.value.lat" :class="{ 'text-strike': correct === false }">{{ event_value.value.name }} ({{ event_value.value.country }})</span>
        <span v-else="event_value.value" :class="{ 'text-strike': correct === false }">{{ event_value.value }}</span> -->

        <i v-show="(showIcons || correct === true) && !loading" 
           :class="{ 'fas fa-check text-success icon': true, 'icon-opacity': !(correct === true), 'icon-spacing': true }" 
           :title="current_user_label ? current_user_label.created_at : null"
           @click="set_correct(correct == true ? null : true)"></i>
        <i v-show="(showIcons || correct === false) && !loading" 
           :class="{ 'fas fa-times text-danger icon': true, 'icon-opacity': !(correct === false), 'icon-spacing': true }" 
           :title="current_user_label ? current_user_label.created_at : null"
           @click="set_correct(correct == false ? null : false)"></i>
        <i v-show="(showIcons && correct === false) && !loading" 
           :class="{ 'fas fa-edit text-primary icon': true, 'icon-opacity': !(correct === false), 'icon-spacing': true }" 
           @click="edit_new_value = !edit_new_value"></i>
        <div class="input-group">
            <input
            v-if="edit_new_value"
            type="text"
            v-model="current_user_label.new_value"
            @keyup.enter="save_new_value"
            class="form-control" />
            <button v-if="edit_new_value" class="btn btn-outline-secondary btn-sm" type="button" @click="save_new_value">
                <i class="fas fa-save"></i>
            </button>
        </div>
        <i v-show="loading" class="fas fa-spinner fa-spin icon-spacing"></i>

        <span v-if="event_value.user_labels && showIcons">
            <i v-for="user_label in event_value.user_labels" :key="user_label.id"
               :class="{'fas fa-user-check text-success fa-xs icon-opacity': user_label.correct, 'fas fa-user-times text-danger fa-xs icon-opacity': !user_label.correct}" 
               :title="`Created by ${user_label.email} at ${user_label.created_at}`"></i>
        </span>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: "event-value",
    data() {
        return {
            value: null,
            correct: null,
            current_user_id: null,
            current_user_label: null,
            showIcons: false,
            loading: false,
            edit_new_value: false
        }
    },
    props: {
        event_value: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: false
        }
    },
    mounted() {
        this.current_user_id = window.$user_id;
        this.set_internal_data();
        
        // if options.always_visible is true and current_user_id is set, then show the icons
        if (this.always_visible && this.current_user_id) {
            this.showIcons = true;
        }
    },
    watch: {
        event_value: {
            handler: function (new_val, old_val) {
                this.set_internal_data();
            },
        }
    },
    methods: {
        set_internal_data() {
            this.value = this.event_value.value;
            
            // convert value to str if needed
            // if it is a location, then display the name and country
            // if it is an object with keys and values, display them as "key: value"
            // except if keys are numbers
            if (this.value && this.value.lat) {
                this.value = this.value.name + ' (' + this.value.country + ')';
            } else if (this.value && typeof this.value === 'object') {
                let str = '';
                for (let key in this.value) {
                    if (isNaN(key)) {
                        str += key + ': ' + this.value[key] + ', ';
                    } else {
                        str += this.value[key] + ', ';
                    }
                }
                this.value = str.slice(0, -2);
            }

            this.correct = null;
            this.current_user_label = null;
            if (this.event_value.user_labels) {
                for (let i = 0; i < this.event_value.user_labels.length; i++) {
                    if (this.event_value.user_labels[i].user_id === this.current_user_id) {
                        this.current_user_label = this.event_value.user_labels[i];
                        this.correct = this.event_value.user_labels[i].correct;
                        break;
                    }
                }
            }
        },
        set_correct(value) {
            this.loading = true;
            this.correct = this.correct === value ? null : value;
            axios.put('/events/set-user-label/' + this.event_value.id + '/', { correct: value })
                .then(response => {
                    // response is a 2-tuple with the user label and all the user labels
                    this.current_user_label = response.data[0] ? response.data[0] : null;
                    this.emit_user_labels_change(response.data[1]);

                    if (this.current_user_label)
                        this.correct = this.current_user_label.correct;
                    else
                        this.correct = null;
                    
                    // if response.data is null, then the user label was deleted
                    // and it should be removed from the list of user labels
                    // otherwise it should be updated
                    if (this.event_value.user_labels) {
                        for (let i = 0; i < this.event_value.user_labels.length; i++) {
                            if (this.event_value.user_labels[i].user_id === this.current_user_id) {
                                if (this.current_user_label === null) {
                                    this.event_value.user_labels.splice(i, 1);
                                } else {
                                    this.event_value.user_labels[i] = this.current_user_label;
                                }
                                break;
                            }
                        }
                    }
                    this.emit_user_labels_change(this.event_value.user_labels);
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        save_new_value() {
            this.loading = true;
            axios.put('/events/set-user-label/' + this.event_value.id + '/', { new_value: this.current_user_label.new_value })
                .then(response => {
                    // update current_user_label and correct from response.data
                    this.current_user_label = response.data ? response.data : null;
                    this.emit_user_labels_change(this.event_value.user_labels);
                    this.loading = false;
                    this.edit_new_value = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        emit_user_labels_change(new_user_labels) {
            console.log('user-labels-change', new_user_labels);
            this.$emit('user-labels-change', new_user_labels);
        }
    },
    computed: {
        always_visible() {
            return this.options && this.options.always_visible;
        }
    }
}
</script>

<style scoped>
.text-strike {
    text-decoration: line-through;
}

.icon {
    cursor: pointer;
}

.icon-opacity {
    opacity: 0.5;
}

.icon-spacing {
    margin-left: 10px;
    margin-right: 10px;
}
</style>